<script>
// 筆數在父層(perPage)都預設顯示10筆
// 子層(SublayerPage)預設15、30、50筆
// 選擇後，透過$emit在父層methods的RecPerPage()接收參數
// 改變(perPage)資料，以呈現該數量的表格
export default {
  data () {
    return {
      SublayerPage: 10, // 顯示筆數
      pageOptions: [ // 筆數數量選項
        { text: '15', value: 15 },
        { text: '30', value: 30 },
        { text: '50', value: 50 }
      ]
    }
  },
  methods: {
    pages () { // 傳遞給父層接收，使表格筆數變動
      this.$emit('RecPerPage', this.SublayerPage)
    }
  }
}
</script>

<template>
  <div>
    <select
      id="Page-select"
      class="input-style"
      v-model="SublayerPage"
      :pageOptions="pageOptions"
      @change="pages"
    >
      <option
        v-for="pageOption in pageOptions"
        :key="pageOption.id"
        :value="pageOption.value"
      >
        {{ pageOption.text }}
      </option>
    </select>
  </div>
</template>
